module.exports = __webpack_public_path__ + "img/084-barbados.6e659ff2.svg";